import { Controller } from '@hotwired/stimulus';

const INTERVAL = 3000;

export default class extends Controller {
  // ready target は準備完了のレスポンス（csv_file_download）が持つ
  static targets = ['ready'];

  static values = { url: String };

  connect() {
    this.timer = setInterval(() => this.#poll(), INTERVAL);
  }

  disconnect() {
    this.#stop();
  }

  async #poll() {
    let response;
    try {
      response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          Accept: 'text/html',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
            ?.content,
        },
      });
    } catch (error) {
      console.error(error);
      return;
    }

    if (!response.ok) {
      await this.#alertErrorResponse(response);
      return;
    }

    const html = await response.text();
    this.element.innerHTML = html;
    // 出力を始めていない（cookie がない）と空が返る
    // 準備完了のあとは同じ表示が続き、問い合わせるたびに presigned URL を発行するだけなので止める
    if (html.trim() === '' || this.hasReadyTarget) this.#stop();
  }

  #stop() {
    clearInterval(this.timer);
  }

  // 失敗しても止めずに次の問い合わせを続けるので、画面に alertify が出ていれば重ねない
  async #alertErrorResponse(response) {
    let errors;
    try {
      ({ errors } = await response.json());
    } catch (error) {
      console.error(error);
      return;
    }
    if (document.querySelector('.alertify-notifier .ajs-message')) return;

    for (const error of errors ?? []) {
      alertify.error(error);
    }
  }
}
